import { useRouter } from 'next/router';

import { Pagination } from '../../resources/shared/types/pagination';

export function useCurrentPageFromRouterAndPagination(
    pagination: Pick<Pagination, 'firstPage' | 'lastPage'>,
): number {
    const { query } = useRouter();
    const { firstPage, lastPage } = pagination;

    const page = parseInt(query.p as string, 10);
    const isInvalidPage = isNaN(page) || page < firstPage || page > lastPage;

    return isInvalidPage ? firstPage : page;
}
